<template>
  <header data-v-e82090a2="" data-v-2ac6a5fc="" class="header-container">
    <div style="position:relative;top:0px;left: 0px;z-index: 999;width: 100vw;background-color: #000;" v-show="appShow && $route.path != '/myNews'">
      <div style="float: left;height: 50px;width: 30px;">
        <van-icon name="cross" size="28" style="margin: 10px 5px;" color="#666" @click="closeApp" />
      </div>
      <div style="float: left;height: 50px;">
        <img :src="$store.state.appInfo.site_logo" style="width: 40px ;height: 40px;margin:5px;" />
      </div>
      <div style="float: left;height: 50px;line-height: 1.3;padding-top: 6px;">
        <p style="font-size: 16px;font-weight: 500;color: #fff;">{{ $store.state.appInfo.title }}</p>
        <span style="font-size: 12px;">下载APP 领取红包 游戏尽在一手掌握</span>
      </div>
      <div style="position: absolute;right: 8px;">
        <div style="background:linear-gradient(224deg, rgb(204, 163, 82), rgb(255, 203, 76));height: 32px;line-height: 32px;padding: 0px 18px;border-radius: 16px;margin-top: 6px;font-weight: 500;">
          <a v-if="isIos" :href="$store.state.appInfo.ios_download_url" target="_bank" style="color: #fff;">
          下载APP</a>
        
        <a v-else :href="$store.state.appInfo.android_download_url" target="_bank" style="color: #fff;">
          下载APP</a>
        </div>
      </div>
      <div style="clear: both;" />
    </div>
    <div data-v-e82090a2="" class="header-new-center" style="background-color: #000;">
      <div data-v-e82090a2="" class="button-left" v-if="bankShow"><span data-v-e82090a2="" class="back" @click="pageBack()"></span></div>
      <h1 data-v-e82090a2="" class="header-title" v-if="titleShow">
        <span data-v-e82090a2="">{{ title }}</span>
      </h1>
      <button data-v-e82090a2="" v-if="!bankShow" class="header-button left"><i data-v-e82090a2="" class="icon icon-menu2"></i></button>
      <h1 data-v-e82090a2="" v-if="!titleShow" class="header-title">
        <img
          data-v-e82090a2=""
          src="/static/image/205-60-2.png"
          alt="LOGO"
          class="logo" style="height: 40px;"
        />
      </h1>
      <div data-v-e82090a2="" class="header-button right" style="display: flex; align-items: center;">
        <i data-v-e82090a2="" @click="$parent.goNav('/myNews')" class="icon-letter" style="display: none;"></i>
        <div data-v-6ccba2c2="" data-v-e82090a2="" class="service-container">
          <div data-v-6ccba2c2="" class="service-button"><i data-v-6ccba2c2="" @click="$parent.openKefu()" class="icon-customer-service"></i></div>
          <ul data-v-6ccba2c2="" class="service-menu" v-if="tabShow">
            <li data-v-6ccba2c2="" class="arrow"></li>
            <li data-v-6ccba2c2="" class="service-menu-item" ><i data-v-6ccba2c2="" class="service-menu-item-icon service"></i>在线客服</li>

          </ul>
          <div data-v-6ccba2c2="" class="service-button-mask" v-if="tabShow" @click="changTabShow"></div>
        </div>
      </div>
    </div>
    
  </header>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return {
      tabShow: false,
      bankShow: false,
      titleShow: false,
      title: '',
      appShow:false,
      isIos:false
    };
  },
  created() {
    const _u = navigator.userAgent;
      const ios = _u.indexOf("iPhone") > -1;
      const iPad = _u.indexOf("iPad") > -1;
      if (ios || iPad) {
        this.isIos = true
      } else {
        this.isIos = false
      }
    let that = this;
    this.changPath();
    if(sessionStorage.getItem('appShow') != null){
      this.appShow = JSON.parse(sessionStorage.getItem('appShow'))
      }
    else
      this.appShow = true
  },
  methods: {
    pageBack(){
      
      if (this.$route.name == 'accountCenter') {
        this.$parent.goNav('/userCenter')
      }
      else {
        if(this.$route.name == 'gamePage'){
          this.$apiFun.get('/api/backGame', {}).then(res => {});
          this.$parent.goNav('/')
        }
        else {
          this.$router.back()
        }
      }
    },
    closeApp(){
      
      this.appShow = false
      sessionStorage.setItem('appShow',JSON.stringify(this.appShow))
    },
    changTabShow(event) {
      event.stopPropagation();
      this.tabShow = !this.tabShow;
    },
    changPath() {
      let that = this;
      let path = this.$route.path;
      if (path == '/') {
        that.bankShow = false;
        that.titleShow = false;
        that.title = '';
      }
            if (path == '/kefu') {
        that.bankShow = false;
        that.titleShow = false;
        that.title = '连线客服';
      }
      
      if (path == '/about') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '关于我们';
      }
      if (path == '/faq') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '帮助中心';
      }
      if (path == '/userCenter') {
        that.bankShow = false;
        that.titleShow = true;
        that.title = '会员中心';
      }
      if (path == '/accountCenter') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '账户中心';
      }
      if (path == '/resetPasswordNew') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '修改密码';
      }
      if (path == '/modifyPhone') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '设置手机号';
      }
      if (path == '/modifyEmail') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '设置邮箱';
      }
      if (path == '/modifyPayPassword') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '设置资金密码';
      }
      if (path == '/bankCard') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '我的银行卡';
      }
      if (path == '/addBankCard') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '添加银行卡';
      }
      if (path == '/addUsdtCard') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '添加USDT钱包';
      }
      if (path == '/myNews') {
        that.closeApp()
        that.bankShow = true;
        that.titleShow = true;
        that.title = '我的消息';
      }
      if (path == '/myNewsInfo') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '消息详情';
      }
      if (path == '/assets') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '资产';
      }
      if (path == '/applyagent') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '申请代理';
      }
      if (path == '/applyagentList') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '活动申请记录';
      }
      if (path == '/activeList') {
        that.bankShow = false;
        that.titleShow = true;
        that.title = '优惠活动';
      }
      if (path == '/activeInfo') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '活动详情';
      }
      if (path == '/app') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = 'APP / 游戏下载';
      }
      if (path == '/sponsor') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = that.$store.state.appInfo.title + '风采';
      }
      if (path == '/vip') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = 'VIP专区';
      }
      if (path == '/deposit') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '存款';
      }
      if (path == '/withdraw') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '取款';
      }
      if (path == '/games') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '游戏大厅';
      }
      if (path == '/gamePage') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '';
      }
      if (path == '/welfare') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '福利中心';
      }
            if (path == '/hongbao') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '抢红包';
      }
    },
  },
  mounted() {
    $('.mask .close').click(function () {
      $(this).parents('.mask').fadeOut(300);
    });
    $('.user').hover(function () {
      $(this).find('.userImg .userNav').toggleClass('userNav--active');
    });
  },
  updated() {
    let that = this;
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.service-menu .service-menu-item[data-v-6ccba2c2] {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/libs/Header.vue